import { type ComponentType } from 'react';
import { z } from 'zod';

import { api, isDefined } from 'common';

import JobKind = api.RpaJob.Kind;

export const VARIABLE_REGEX = /^\{\{\S+\}\}$/;

export interface AsynchronousJobVariant {
  schema: z.ZodObject<{ jobKind: z.ZodLiteral<JobKind> }>;
  Config: ComponentType;
}

export const OptionalStringSchema = z.string().optional();
export const NullableStringSchema = OptionalStringSchema.nullable();
export const RequiredStringSchema = z.string().min(1);

export const PatientSexUpperSchema = z
  .string()
  .refine(
    (patientSex) =>
      isDefined(patientSex) &&
      (Object.values(api.Common.Sex).includes(patientSex as api.Common.Sex) ||
        VARIABLE_REGEX.test(patientSex.trim()))
  );

export const PatientSexSchema = z
  .string()
  .refine(
    (patientSex) =>
      isDefined(patientSex) &&
      (Object.values(api.Patient.Sex).includes(patientSex as api.Patient.Sex) ||
        VARIABLE_REGEX.test(patientSex.trim()))
  );

export function getEnumOrFlowTemplateVariableSchema<T>(values: Record<string, T> | T[]) {
  return z
    .string()
    .refine(
      (value) =>
        isDefined(value) &&
        (Object.values(values).includes(value as T) || VARIABLE_REGEX.test(value.trim()))
    );
}
